{
  "brand": "المسافر",
  "nav": {
    "settings": "الإعدادات",
    "launcher": "الأنظمة",
    "employees": "الموظفين",
    "branches": "الفروع",
    "changeBranch": "تغيير الفرع",
    "language": "اللغة",
    "theme": "المظهر",
    "changePassword": "تغيير كلمة المرور",
    "toggleSidebarHint": "إظهار/إخفاء الشريط الجانبي (Ctrl/Cmd+B)"
  },
  "language": {
    "ar": "العربية",
    "en": "الإنجليزية"
  },
  "action": {
    "save": "حفظ",
    "saving": "جاري الحفظ...",
    "cancel": "إلغاء",
    "edit": "تعديل",
    "delete": "حذف",
    "activate": "تفعيل",
    "deactivate": "تعطيل",
    "confirm": "تأكيد",
    "retry": "تحديث",
    "logout": "تسجيل الخروج",
    "backToLogin": "العودة إلى تسجيل الدخول",
    "close": "إغلاق",
    "search": "بحث",
    "actions": "إجراءات"
  },
  "state": {
    "loading": "جاري التحميل",
    "accessDenied": "تم رفض الوصول",
    "forbidden": "ليس لديك صلاحية لعرض هذه الصفحة"
  },
  "status": {
    "label": "الحالة",
    "ACTIVE": "نشط",
    "INACTIVE": "غير نشط",
    "PENDING": "قيد الانتظار"
  },
  "drawer": {
    "discardTitle": "تجاهل التغييرات؟",
    "discardDescription": "لن يتم حفظ البيانات التي أدخلتها.",
    "discardConfirm": "تجاهل",
    "discardCancel": "متابعة التعديل"
  },
  "field": {
    "actions": "إجراءات"
  },
  "directory": {
    "all": "الكل",
    "allStatuses": "جميع الحالات",
    "noResults": "لا توجد نتائج.",
    "noData": "لا توجد بيانات متاحة",
    "resetFilters": "إعادة تعيين الفلاتر",
    "requiredNote": "الحقول المطلوبة مميزة بعلامة النجمة",
    "showing": "عرض {{start}}-{{end}} من {{total}}",
    "clearFilter": "إزالة الفلتر: {{label}}",
    "previous": "السابق",
    "next": "التالي"
  },
  "launcher": {
    "title": "الأنظمة",
    "description": "اختر النظام الذي تريد فتحه.",
    "empty": "لا توجد أنظمة متاحة لهذا الحساب في هذا الفرع. تواصل مع المدير.",
    "administration": "إدارة الموظفين والفروع",
    "administrationDescription": "إدارة حسابات الموظفين والفروع المشتركة بين الأنظمة."
  },
  "employees": {
    "description": "إدارة حسابات الموظفين المشتركة بين الأنظمة.",
    "add": "إضافة موظف",
    "createTitle": "إنشاء موظف",
    "editTitle": "تعديل الموظف",
    "username": "اسم المستخدم",
    "nameAr": "الاسم بالعربية",
    "nameEn": "الاسم بالإنجليزية",
    "nfcId": "معرف NFC",
    "isAdmin": "مدير النظام",
    "platforms": "الأنظمة",
    "lastLogin": "آخر تسجيل دخول",
    "neverLoggedIn": "لم يسجل الدخول مطلقا",
    "resetPassword": "إعادة تعيين كلمة المرور",
    "removeNfc": "إزالة بطاقة NFC",
    "removeNfcDescription": "ستتم إزالة بطاقة NFC من حساب «{{name}}». لن يتمكن من تسجيل الدخول بالبطاقة بعد الآن.",
    "statusConfirmDescription": "سيتم تغيير حالة حساب «{{name}}».",
    "created": "تم إنشاء الموظف بنجاح",
    "updated": "تم تحديث الموظف بنجاح",
    "deleted": "تم حذف الموظف بنجاح",
    "statusChanged": "تم تغيير حالة الموظف بنجاح",
    "nfcRemoved": "تمت إزالة بطاقة NFC بنجاح",
    "resetEmailed": "تم إرسال رابط إعادة تعيين كلمة المرور إلى البريد الإلكتروني الموثق.",
    "resetLinkDescription": "لا يوجد بريد إلكتروني موثق لهذا الموظف. انسخ الرابط أدناه وسلمه له مباشرة؛ يظهر مرة واحدة فقط.",
    "copyLink": "نسخ الرابط",
    "linkCopied": "تم نسخ الرابط"
  },
  "branches": {
    "description": "إدارة الفروع المشتركة بين الأنظمة.",
    "add": "إضافة فرع",
    "createTitle": "إنشاء فرع",
    "editTitle": "تعديل الفرع",
    "code": "الرمز",
    "statusConfirmDescription": "سيتم تغيير حالة فرع «{{name}}». يؤدي التعطيل إلى إخفائه من اختيار الفرع في جميع الأنظمة.",
    "created": "تم إنشاء الفرع بنجاح",
    "updated": "تم تحديث الفرع بنجاح",
    "statusChanged": "تم تغيير حالة الفرع بنجاح"
  },
  "deleteConfirmation": {
    "title": "تأكيد الحذف",
    "description": "سيتم حذف «{{name}}» نهائيا. هل أنت متأكد؟"
  },
  "passwordChanged": "تم تغيير كلمة المرور بنجاح",
  "changePasswordDescription": "أدخل كلمة المرور الحالية، ثم كلمة المرور الجديدة."
}
